import { toast } from "react-toastify";
import apiLink from "../api/apiLink";
import {
  getFixedNumberMessageLogSlice,
  getMaskingMessageLogSlice,
  getMessageLogSlice,
  getPersonalMessageGatewayBalanceSuccess,
  getPersonalMessageGatewayLogsSuccess,
} from "./messageLogSlice";

// get all messge log

export const getMessageLog = async (dispatch, setIsLoading, senderId) => {
  setIsLoading(true);

  try {
    const res = await apiLink.get(`sms/sms-history/${senderId}`);
    dispatch(getMessageLogSlice(res.data.sms));
  } catch (error) {
    console.log(error);
  }
  setIsLoading(false);
};

// get masking messge log
export const getMaskingMessageLog = async (
  dispatch,
  setIsLoading,
  senderId,
) => {
  setIsLoading(true);

  try {
    const res = await apiLink.get(
      `sms/sms-history/masking-and-fixed-number/${senderId}?sendBy=masking`,
    );
    dispatch(getMaskingMessageLogSlice(res.data.sms));
  } catch (error) {
    console.log(error);
  }
  setIsLoading(false);
};

// get masking messge log
export const getFixedNumberMessageLog = async (
  dispatch,
  setIsLoading,
  senderId,
) => {
  setIsLoading(true);

  try {
    const res = await apiLink.get(
      `sms/sms-history/masking-and-fixed-number/${senderId}?sendBy=fixed_number`,
    );
    dispatch(getFixedNumberMessageLogSlice(res.data.sms));
  } catch (error) {
    console.log(error);
  }
  setIsLoading(false);
};

export const getPersonalMessageGatewayLogs = async (dispatch, setIsLoading) => {
  setIsLoading(true);

  try {
    const res = await apiLink.get("sms/ispOwner/personal/message/gateway/logs");

    dispatch(getPersonalMessageGatewayLogsSuccess(res.data.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};

export const getPersonalMessageGatewayBalance = async (
  dispatch,
  setIsLoading,
) => {
  setIsLoading(true);

  try {
    const res = await apiLink.get(
      "sms/ispOwner/personal/message/gateway/balance",
    );

    dispatch(getPersonalMessageGatewayBalanceSuccess(res.data.data));
  } catch (error) {
    toast.error(error.message);
  }
  setIsLoading(false);
};
